import { useFlagVariation } from '@customink/signalmizely-react';
import { useMemo } from 'react';

export const useSignalmizelyFlagEnabled = (flagName: string) => {
    const { variation } = useFlagVariation(flagName);
    return useMemo(() => {
        return variation === 'test';
    }, [variation]);
};
